module.exports = __webpack_public_path__ + "img/avatar5.d30fd13d.png";